import React from "react";
import { AttributeDefaultHeaderWrapper } from "./styles";
import AttributeInnerCard from "./AttributeInnerCard";
import { Ptag } from "components/core";

function AttributeCoPayment({ data }) {
  return (
    <div
      // fix this css
      style={{
        display: "flex",
        gap: "24px",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div style={{ width: "100%" }}>
        {data?.esc && (data?.esc?.limit || data?.esc?.min || data?.esc?.max) && (
          <>
            <div style={{ width: "100%" }}>
              {/* <Ptag fontSize="14px" fontWeight="600" marginBottom="18px">
                For Employee, Spouse and Children
              </Ptag>
              <AttributeDefaultHeaderWrapper>
                <AttributeInnerCard
                  title={data?.esc?.min || data?.esc?.max ? "Default" : "Limit"}
                  value={data?.esc?.limit}
                  width="100%"
                />
                {data?.esc?.min && (
                  <AttributeInnerCard
                    title="Minimum Limit"
                    value={data?.esc?.min}
                    width="200px"
                  />
                )}
                {data?.esc?.max && (
                  <AttributeInnerCard
                    title="Maximum Limit"
                    value={data?.esc?.max}
                    width="200px"
                  />
                )}
              </AttributeDefaultHeaderWrapper> */}


              <div className="maternity-card-css">
                <div class="spacing-css">
                  <div>
                    <span className="maternity-card-heading-css">
                      {"For Employee, Spouse and Children"}
                    </span>
                  </div>
                  <div className="gold-line-css" />
                </div>

                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "16px",
                  gap: "8px"
                }}>
                  <span className='maternity-max-limit-heading'>
                    {data?.esc?.min || data?.esc?.max ? "Default" : "Limit"}
                  </span>
                  <span className='maternity-max-limit-value'>
                    {data?.esc?.limit ? data?.esc?.limit : "-"}
                  </span>
                </div>

                <div style={{
                  display: data?.esc?.max ? "flex" : "none",
                  flexDirection: "column",
                  marginTop: "16px",
                  gap: "8px"
                }}>
                  <span className='maternity-max-limit-heading'>
                    {"Max"}
                  </span>
                  <span className='maternity-max-limit-value'>
                    {data?.esc?.max ? data?.esc?.max : "-"}
                  </span>
                </div>

                <div style={{
                  display: data?.esc?.min ? "flex" : "none",
                  flexDirection: "column",
                  // marginTop: "16px",
                  gap: "8px"
                }}>
                  <span className='maternity-max-limit-heading'>
                    {"Min"}
                  </span>
                  <span className='maternity-max-limit-value'>
                    {data?.esc?.min ? data?.esc?.min : "-"}
                  </span>
                </div>
              </div>

            </div>
          </>
        )}
      </div>
      <div style={{ width: "100%" }}>
        {data?.parents && (data?.parents?.min || data?.parents?.max || data?.parents?.limit) && (
          <>
            <div style={{ width: "100%" }}>
              {/* <Ptag
                fontSize="14px"
                fontWeight="600"
                marginBottom="18px"
              >
                For Parents
              </Ptag>
              <AttributeDefaultHeaderWrapper>
                <AttributeInnerCard
                  title={
                    data?.parents?.min || data?.parents?.max ? "Default" : "Limit"
                  }
                  value={data?.parents?.limit}
                  width="200px"
                />
                {data?.parents?.min && (
                  <AttributeInnerCard
                    title="Minimum Limit"
                    value={data?.parents?.min}
                    width="200px"
                  />
                )}
                {data?.parents?.max && (
                  <AttributeInnerCard
                    title="Maximum Limit"
                    value={data?.parents?.max}
                    width="200px"
                  />
                )}
              </AttributeDefaultHeaderWrapper> */}

              <div className="maternity-card-css">
                <div class="spacing-css">
                  <div>
                    <span className="maternity-card-heading-css">
                      {"For Parents"}
                    </span>
                  </div>
                  <div className="gold-line-css" />
                </div>

                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "16px",
                  gap: "8px"
                }}>
                  <span className='maternity-max-limit-heading'>
                    {data?.parents?.min || data?.parents?.max ? "Default" : "Limit"}
                  </span>
                  <span className='maternity-max-limit-value'>
                    {data?.parents?.limit ? data?.parents?.limit : "-"}
                  </span>
                </div>

                <div style={{
                  display: data?.parents?.max ? "flex" : "none",
                  flexDirection: "column",
                  marginTop: "16px",
                  gap: "8px"
                }}>
                  <span className='maternity-max-limit-heading'>
                    {"Max"}
                  </span>
                  <span className='maternity-max-limit-value'>
                    {data?.parents?.max ? data?.parents?.max : "-"}
                  </span>
                </div>

                <div style={{
                  display: data?.parents?.min ? "flex" : "none",
                  flexDirection: "column",
                  // marginTop: "16px",
                  gap: "8px"
                }}>
                  <span className='maternity-max-limit-heading'>
                    {"Min"}
                  </span>
                  <span className='maternity-max-limit-value'>
                    {data?.parents?.min ? data?.parents?.min : "-"}
                  </span>
                </div>
              </div>


            </div>
            {/* <article>
              {data?.parents?.remarks && (
                <Ptag fontWeight="400" color="#4a4a4a" marginTop="18px">
                  Remarks: {data?.parents?.remarks}
                </Ptag>
              )}
            </article> */}
          </>
        )}
      </div>
    </div>
  );
}

export default AttributeCoPayment;
